var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Información"}},[_c('informacion',{attrs:{"id":_vm.idusuario}})],1),_c('vs-tab',{attrs:{"label":"Asignaturas"}},[_c('asignaturas',{attrs:{"id":_vm.idusuario}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }